module.exports = __webpack_public_path__ + "img/pt.396141d5.svg";